class PropertyFinanceController {
    constructor(propertiesService, messageService, access, configService) {
        this.propertiesService = propertiesService;
        this.messageService = messageService;
        this.access = access;
        this.configService = configService;
    }

    $onInit () {
        this.stripeTestEnv = this.configService.get('gateways')['stripe']['account'] || false;
        this.details = this.property[this.type] || {};
        this.connectRedirectUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${this.configService.get('gateways.stripe.clientId')}&scope=read_write&redirect_uri=${this.configService.get('appUrl')}/admin/connect&state=${this.property.id}`;
    }

    onSave () {
        return this.propertiesService.updateDetails(this.details, this.property.id, this.type)
            .then(() => {
                this.messageService.success(`The ${this.type} details for <strong>${this.property.name}</strong> were successfully updated!`);
                this.formTab = 'property';
                this.property[this.type] = this.details;
                this.messageService.push();
                this.messageService.autoClear();
            })
            .catch((error) => {
                this.messageService.failure(`The ${this.type} details for <strong>${this.property.name}</strong> could not be successfully updated: ${error.statusText}`);
                this.messageService.push();
            }).then(() => {
                this.updating = false;
            });
    }

    disconnectFromGateway (gateway) {
        switch (gateway) {
            case 'stripe':
                this.details.stripe_user_id = undefined;
                break;

            default:
                return false;
        }

        this.updating = true;
        return this.onSave();
    }

    isConnected (gateway) {
        switch (gateway) {
            case 'stripe':
                return !!this.details.stripe_user_id;
        }
        return false;
    }

    displayPaymentGatewayName () {
        switch (this.details.payment_gateway) {
            case 'stripe':
                return 'Stripe';
            case 'paysafe':
                return 'Paysafe';
            default:
            case 'none':
                return 'No payment gateway';
        }
    }

    setDummyStripe()
    {
        this.details.stripe_user_id = this.stripeTestEnv;
        this.notSaved = true;
    }
}

PropertyFinanceController.$inject = ['propertiesService', 'messageService', 'access', 'configService'];

export default PropertyFinanceController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.finance.controller.js